import { css } from "@emotion/css";
import PageContent from "../../../../components/molecule/pageContent";
import { RiArrowGoBackLine } from "@remixicon/react";

const MemoriasDaAlmaOcultoSimbolos = () => {
    const pageCSS = css`
        .kt-page-content-primary {
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            box-sizing: border-box;
            padding: 10%;
            padding-top: calc(10% + 100px);
    
            h1 {
                background-color: #1b0a02;
                box-sizing: border-box;
                padding: 15px 0px 15px 1rem;
                font-weight: 400;
                letter-spacing: 1rem;
                color: #ffffff;
                width: fit-content;
                font-family: 'Fira Code', monospace;
                text-align: center;
                font-size: ${window.innerWidth > 500 ? "3.75rem" : "2.75rem"};
            }
    
            .brand {
                position: absolute;
                top: 10%;
                left: 10%;
                color: #ffffff;
                font-family: 'Fira Code', monospace;
                letter-spacing: 0.5rem;
                width: max-content;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                
                &::before {
                    content: 'ARQUIVO VIVO';
                    width: fit-content;
                    font-size: 1.75rem;
                }
                    
                &::after {
                    content: 'MEMÓRIAS DA ALMA';
                    width: fit-content;
                    font-size: .75rem;
                }
            }
    
            &#first {
                background-image: url('/img/bg_5.jpeg');
            }
    
            &#flores {
                background-image: url('/img/bg_13.jpeg');
            }
    
            &#estacao {
                background-image: url('/img/bg_14.jpeg');
            }
    
            &#relogio {
                background-image: url('/img/bg_15.jpeg');
            }
    
            &#casa {
                background-image: url('/img/bg_16.jpeg');
            }
    
            &#estrelas {
                background-image: url('/img/bg_17.jpeg');
            }
    
            &#portas {
                background-image: url('/img/bg_18.jpeg');
            }
    
            &#saudade {
                background-image: url('/img/bg_19.jpeg');
            }
        }
    
        .kt-page-content-secondary {
            text-align: center;
            font-family: 'Source Code Pro', Arial;
            font-weight: 500;
            font-size: 2rem;
            padding: 50px;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            text-transform: uppercase;
    
            &::before {
                content: '';
                position: absolute;
                z-index: -1;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                background-repeat: no-repeat;
                background-size: cover;
                background-image: url('/img/bg_1.jpeg');
                background-position: center;
            }
    
            p {
                margin: 0;
                line-height: 2.5rem;
                color: #ffffff;
            }
        }

        #return-to-lobby {
            position: fixed;
            bottom: 20px;
            left: 20px;
            font-size: 2rem;
            color: #ffffff;
            cursor: pointer;
            background-color: #1b0a02;
            padding: 10px;
            border-radius: 50%;
            z-index: 1000;
            border: 1px solid #c39b54;
            opacity: 1;
            transition: 0.5s;

            &:hover {
                background-color: #c39b54;
                color: #1b0a02;
                transform: scale(1.05);
                transition: 0.5s;
            }
        }
    `;

    return (<div className={pageCSS}>
        <PageContent id="first" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>OS SÍMBOLOS</h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Toda história possui uma linguagem invisível.<br/>
                Em Memórias da Alma, essa linguagem é construída<br/>
                por símbolos.<br/><br/>

                Eles não foram criados para serem decifrados como<br/>
                enigmas. Foram escritos para serem sentidos.<br/><br/>

                Um símbolo nunca diz apenas uma coisa.<br/>
                Ele muda conforme a percepção de quem a contempla.<br/><br/>

                Por isso, talvez uma flor signifique esperança para<br/>
                um leitor e despedida para outro. Uma estação<br/>
                represente um reencontro para alguém e um tempo de<br/>
                espera para outra pessoa.<br/><br/>

                Nenhuma dessas leituras está errada.<br/>
                Porque os símbolos pertencem menos ao autor e mais<br/>
                àquele que os recebe.<br/>
                Enquanto escrevia este livro, percebi que algumas<br/>
                ideias não cabiam em explicações. Precisavam de imagens.<br/><br/>

                As flores.<br/>
                A estação.<br/>
                O relógio.<br/>
                A Casa.<br/>
                As estrelas.<br/>
                As portas.<br/>
                A saudade.<br/><br/>

                Cada um desses elementos tornou-se uma linguagem<br/>
                silenciosa, capaz de dizer aquilo que as palavras,<br/>
                sozinhas, não alcançariam.<br/><br/>

                A literatura simbólica não procura oferecer respostas prontas.<br/>
                Ela convida o leitor a participar da criação do significado.<br/>
                É por isso que dois leitores podem atravessar<br/>
                exatamente as mesmas páginas e sair delas<br/>
                carregando histórias diferentes.<br/><br/>

                O livro permanece o mesmo.<br/>
                Quem muda é o olhar.<br/><br/>

                Nas próximas portas, compartilho algumas reflexões<br/>
                que inspiraram cada símbolo. Elas não pretendem<br/>
                revelar um significado definitivo, mas apenas abrir<br/>
                novas possibilidades de contemplação.<br/><br/>

                Se, ao final, você descobrir um sentido que nunca<br/>
                esteve escrito aqui, guarde-o com carinho.<br/><br/>

                Talvez esse seja o símbolo que sempre pertenceu à<br/>
                sua própria história.<br/>

                Porque alguns símbolos não foram colocados no livro<br/>
                para serem compreendidos.<br/><br/>
                
                Foram colocados para serem reconhecidos.
            </p>
        </PageContent>
        <PageContent id="flores" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>AS FLORES</h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                As flores que aparecem em Memórias da Alma nunca foram apenas flores.<br/>
                Elas representam aquilo que continua florescendo, mesmo depois das<br/>
                tempestades.<br/><br/>

                Enquanto tudo muda, elas permanecem anunciando que a beleza ainda<br/>
                encontra um caminho para existir.<br/><br/>

                As flores também são vestígios.<br/>
                Como pequenas mensagens deixadas pela vida para lembrar que a<br/>
                esperança sempre encontra uma forma de nascer.<br/><br/>

                Talvez cada flor seja um lembrete de que a alma também floresce em<br/>
                silêncio, muitas vezes sem perceber.<br/>
                Por isso, elas acompanham os momentos mais importantes da história.<br/><br/>
                
                Não como enfeites.<br/>
                Mas como testemunhas do invisível.
            </p>
        </PageContent>
        <PageContent id="estacao" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>A ESTAÇÃO</h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                A estação não é apenas um lugar.<br/>
                Ela representa todos os momentos da vida em que<br/>
                ainda não chegamos, mas também já não pertencemos<br/>
                ao lugar de onde partimos.<br/><br/>

                É o espaço entre o antes e o depois.<br/>
                Entre a espera, o encontro ou a partida.<br/>
                Entre o medo e a coragem.<br/>
                Na estação, ninguém permanece para sempre.<br/>
                
                Ela existe para lembrar que toda alma está em<br/>
                viagem.<br/><br/>

                Talvez a vida inteira seja uma grande estação.<br/>
                E talvez o verdadeiro destino nunca tenha sido um<br/>
                lugar, mas a pessoa que nos tornamos durante a<br/>
                caminhada.
            </p>
        </PageContent>
        <PageContent id="relogio" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>O RELÓGIO</h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                As 3:33<br/><br/>

                Há horas que marcam o relógio.<br/>
                E há horas que marcam a alma.<br/><br/>

                Em Memórias da Alma, 3:33 representa o<br/>
                instante em que o tempo parece suspender<br/>
                sua lógica.<br/><br/>

                É quando o invisível toca o visível.<br/>
                Quando uma lembrança desperta.<br/>
                Quando algo pede para ser visto.<br/><br/>

                Não importa o significado que cada leitor<br/>
                atribua a esse horário.<br/><br/>

                O mais importante é aquilo que ele<br/>
                desperta.<br/><br/>

                Porque existem momentos que não medem<br/>
                minutos.<br/><br/>

                Medem transformações.
            </p>
        </PageContent>
        <PageContent id="casa" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>A CASA</h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Todos procuramos uma casa.<br/>
                Mas nem sempre estamos procurando paredes.<br/>
                Às vezes, procuramos paz.<br/>
                Pertencimento.<br/>
                Descanso.<br/><br/>

                A sensação de finalmente deixar de procurar.<br/>
                A Casa simboliza esse lugar interior onde a alma<br/>
                reconhece que chegou.<br/><br/>

                Para alguns, ela será uma pessoa.<br/>
                Para outros, um propósito.<br/>
                Para outros ainda, Deus.<br/><br/>

                Talvez a verdadeira Casa nunca tenha sido um<br/>
                endereço.<br/>
                Talvez sempre tenha sido um estado da alma.
            </p>
        </PageContent>
        <PageContent id="estrelas" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>AS ESTRELAS</h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                As estrelas sempre estiveram lá.<br/>
                Mesmo quando as nuvens as escondem.<br/><br/>

                Elas simbolizam aquilo que permanece<br/>
                verdadeiro, ainda que não possa ser<br/>
                visto.<br/><br/>

                Também lembram que somos pequenos diante<br/>
                do universo.<br/><br/>

                Mas não insignificantes.<br/>
                Cada estrela é um convite para olhar além<br/>
                de nós mesmos.<br/><br/>

                E, talvez, para lembrar que a luz sempre<br/>
                percorre longas distâncias antes de<br/>
                alcançar quem a contempla.<br/><br/>

                Assim também acontece com o amor, com a<br/>
                esperança e com a verdade.
            </p>
        </PageContent>
        <PageContent id="portas" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>AS PORTAS</h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Nenhuma porta existe apenas para separar<br/>
                ambientes.<br/><br/>

                Toda porta guarda uma escolha.<br/><br/>

                Ao atravessá-la, deixamos uma versão de<br/>
                nós para trás e permitimos que outra<br/>
                continue a caminhada.<br/><br/>

                Em Memórias da Alma, as portas<br/>
                representam transformação.<br/><br/>

                Elas lembram que toda mudança exige<br/>
                coragem.<br/><br/>

                Nem sempre sabemos o que encontraremos do<br/>
                outro lado.<br/><br/>

                Mas permanecer para sempre diante da<br/>
                mesma porta também é uma forma de não<br/>
                viver.<br/><br/>

                Talvez a vida seja feita menos dos<br/>
                lugares onde chegamos e mais das portas<br/>
                que tivemos coragem de atravessar.
            </p>
        </PageContent>
        <PageContent id="saudade" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>A SAUDADE</h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Se existe um símbolo que sustenta toda a<br/>
                história, é a saudade.<br/><br/>

                Mas não a saudade comum.<br/>
                É a saudade daquilo que nunca soubemos<br/>
                explicar.<br/><br/>

                A ausência que existe antes da lembrança.<br/><br/>

                O vazio que não pertence necessariamente<br/>
                a uma pessoa, mas à sensação de que algo<br/>
                essencial ainda nos espera.<br/><br/>

                Talvez toda busca humana nasça dessa<br/>
                saudade.<br/><br/>

                Uns a chamam de amor.<br/>
                Outros, de sentido.<br/>
                Outros, de Deus.<br/><br/>
                
                Neste livro, a saudade não é o fim.<br/>
                É o início da caminhada.<br/><br/>

                Porque somente quem sente falta é capaz<br/>
                de procurar.<br/><br/>

                E somente quem procura permanece aberto<br/>
                ao encontro.
            </p>
        </PageContent>
        <a href="/memorias-da-alma/oculto/home/#lobby">
            <RiArrowGoBackLine id="return-to-lobby" />
        </a>
    </div>)
}

export default MemoriasDaAlmaOcultoSimbolos;